<template>
  <rich-button @click="commands.ordered_list" v-bind:isActive="isActive.ordered_list()" v-bind:icon="'list-ol'" />
</template>

<script>
  import NumberListButton from './NumberListButton.ts'
  export default NumberListButton
</script>
